import { useRef, useState } from "react";

import { useOutsideAlerter } from "@/utils/hooks/useOutsideAlerter";

import { StoreSearchControlsComponent } from "./storeSearchControls.components";

export const StoreSearchControls = () => {
    const [filtersOpen, setFiltersOpen] = useState<boolean>(false);

    const filterDrawerRef = useRef<HTMLDivElement | null>(null);
    const filterToggleRef = useRef<HTMLButtonElement | null>(null);

    useOutsideAlerter(() => setFiltersOpen(false), filterDrawerRef, [
        filterToggleRef
    ]);

    const toggleFilters = () => setFiltersOpen((open) => !open);

    return (
        <StoreSearchControlsComponent
            filtersOpen={filtersOpen}
            filterDrawerRef={filterDrawerRef}
            filterToggleRef={filterToggleRef}
            toggleFilters={toggleFilters}
        />
    );
};
